export enum OrderForwardListRequestOrder {
  CONSUMER_ASC = "CONSUMER_ASC",
  CONSUMER_DESC = "CONSUMER_DESC",
  PRODUCER_ASC = "PRODUCER_ASC",
  PRODUCER_DESC = "PRODUCER_DESC",
}

export type OrderForwardListQueryParams = {
  order?: OrderForwardListRequestOrder;
  limit?: number;
  offset?: number;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  producer?: string;
  consumer?: string;
  externalId?: string;
  driver?: string;
};

type OrderForwardListRequest = {
  order?: OrderForwardListRequestOrder;
  limit?: number;
  offset?: number;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  producer?: string;
  consumer?: string;
  externalId?: string;
  driver?: string;
};

export default OrderForwardListRequest;
